"use client";

import Image from "next/image";

interface WhoThisIsForProps {
    title: string;
    description: string;
}

const WhoThisIsFor = ({ title, description }: WhoThisIsForProps) => {
    return (
        <section className="desilo-about2-section bg-color-white section-padding-top">
            <div className="container custom-container">
                <div className="row align-items-stretch ">
                    <div className="col-xl-6">
                        <div className="desilo-about2__thumb overflow-hidden pe-xl-4 h-100">
                            <Image
                                className="w-100 h-fit object-fit-cover"
                                height={400}
                                width={0}
                                sizes="100vw"
                                src="/images/use-case/who_this_is_for.webp"
                                alt="Desilo team is brainstorming and mapping business strategies to build impactful products."
                            />
                        </div>
                    </div>
                    <div className="col-xl-6 gsap-scroll row-margin-top2">
                        <div className="desilo-about2__content ps-xl-4 position-sticky sticky-col">
                            <h2>
                                {title}
                            </h2>
                            <p className="mt-3 mt-lg-4">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhoThisIsFor;
